export const userConstants = {
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  UPDATE_NAME: 'UPDATE_NAME',
  UPDATE_USER: "UPDATE_USER"
};
